import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_ACTIVITY_CREATOR_WINDOW_HANDLER = {
  topic: TOPIC_NAMES.OPEN_ACTIVITY_CREATOR,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/ActivityCreatorWindow')
};